import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	OnDestroy,
	OnInit,
	ViewChild,
} from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';

import {
	catchError,
	switchMap,
	tap,
} from 'rxjs/operators';

import { EMPTY } from 'rxjs';

import { BaseComponent } from '@rs-bank/rs-core';
import { detectChanges, unsubscribeOnDestroy } from '@rs-bank/rs-rxjs-extention';

import { LoaderComponent } from 'ib/internetbank-core/ib-components/loader/loader.component';
import { CARD_PICTURE } from 'ib/internetbank-core/ib-constants/size';

import { InternetbankAppApplicationException } from '../../../common/exceptions/exceptions';
import { ProductsService } from '../../../products/products.service';
import { InsuranceDetail } from '../insurance';
import { InsuranceSectionService } from '../insurance-section.service';

@Component({
	selector: 'app-insurance-detail',
	templateUrl: './insurance-detail.component.html',
	styleUrls: ['./insurance-detail.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class InsuranceDetailComponent extends BaseComponent implements OnInit, OnDestroy {

	@ViewChild('loader', { static: true })
	public loader: LoaderComponent;

	public detailInfo: InsuranceDetail;

	public CARD_PICTURE: typeof CARD_PICTURE = CARD_PICTURE;

	constructor(
		public override  changeDetectorRef: ChangeDetectorRef,
		private productsService: ProductsService,
		private insuranceSectionService: InsuranceSectionService,
		private activatedRoute: ActivatedRoute,
	) {
		super(changeDetectorRef);
	}

	public ngOnInit(): void {
		this.activatedRoute.paramMap
			.pipe(
				tap(() => this.loader.show()),
				switchMap((paramMap: ParamMap) => {
					const agreementIdFromMapValue: string | null = paramMap.get('agreementId');
					const insuranceIdFromMapValue: string | null = paramMap.get('insuranceId');

					const agreementIdValue = agreementIdFromMapValue ? +agreementIdFromMapValue : undefined;
					const insuranceIdValue = insuranceIdFromMapValue ? +insuranceIdFromMapValue : undefined;

					this.productsService.setSelectedProductId(agreementIdValue);
					return this.insuranceSectionService.getDetailInfo(insuranceIdValue, agreementIdValue);
				}),
				catchError((error: InternetbankAppApplicationException) => {
					this.loader.setAppError(error);
					return EMPTY;
				}),
				tap((detailInfo: InsuranceDetail) => {
					this.detailInfo = detailInfo;
					this.loader.hide();
				}),
				detectChanges(this),
				unsubscribeOnDestroy(this),
			)
			.subscribe();
	}

	public override ngOnDestroy(): void {
		super.ngOnDestroy();
		this.productsService.setSelectedProductId(undefined);
	}
}
